<div class="partner-form">
  <div class="rtnav ui-g">
    <div class="ui-g-8 msgbox-8">
      @for (message of partnermsgs; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
    </div>
    @if (!partbtnNav) {
      <div class="ui-g-3"></div>
    }
    @if (partbtnNav) {
      <div class="ui-g-3">
        <button
          type="button"
          pButton
          (click)="editPartnerDetailsCancel()"
          class="ui-button-secondary flat fl-rt">
          Cancel
        </button>
        <button
          type="submit"
          pButton
          (click)="onSubmitPartner()"
          class="flat btnmr fl-rt">
          Save
        </button>
      </div>
    }
    <div class="ui-g-1 edit-history-icon">
      <span
        class="fa fa-pencil ico cpointer fl-rt"
        pTooltip="Edit"
        (click)="editPartnerDetails()"
        (keydown.enter)="editPartnerDetails()"
        tabindex="0"
        tooltipPosition="bottom"></span>
      @if (release === 'Prod') {
        <a
          target="_blank"
          href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSectiond4034f79e79ab6d45be9?filter=Master_Engagement/EngagementKey eq '{{
            incentiveId
          }}'">
          <span
            class="fa fa-history ico cpointer fl-rt"
            pTooltip="History"
            tooltipPosition="bottom">
          </span>
        </a>
      }
      @if (release !== 'Prod') {
        <a
          target="_blank"
          href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSectiond4034f79e79ab6d45be9?filter=Master_Engagement/EngagementKey eq '{{
            incentiveId
          }}'">
          <span
            class="fa fa-history ico cpointer fl-rt"
            pTooltip="History"
            tooltipPosition="bottom">
          </span>
        </a>
      }
    </div>
  </div>
  <form [formGroup]="formPartner" class="ui-g-12">
    <div class="readonlytbox">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="hdorg">System Generated</div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="hdorg">PMO Confirmed</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">MPNID</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input type="text" pInputText readonly formControlName="mPNID" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlypart"
            formControlName="pmomPNID" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Name</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="partnerName" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlypart"
            formControlName="pmopartnerName" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          Partner Input - Requestor Contact
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlypart"
            formControlName="partnerInputRequestorContact" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Input - Partner Info</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlypart"
            formControlName="partnerInputRequestorEmail" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Location</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            value="United States"
            formControlName="countryName" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="hdbl">Internal Reference</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Name</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="InternalRefPartnerName" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner One ID</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="partnerOneID" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Location</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="partnerLocation" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Earned Location</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="partnerEarnedLocation" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Area Location (A14)</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            readonly
            formControlName="partnerAreaLocationA14" />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Additional Contact Info</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            pInputText
            [readonly]="isReadonlypart"
            formControlName="additionalContactEmails" />
        </div>
      </div>
    </div>
  </form>
</div>
